// FLAGS: none
// The operator's own in-app notification list and its read-receipt mutation.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryIdentifiers } from "@src/utils/constants";
import { Notifications } from "@src/api/v1/Notifications";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";
import { hours } from "./staletimes";

const excludedNotificationKeys = ["ConsultTranscription"];

export const useGetNotificationsQuery = () => {
  return useQuery({
    queryKey: [queryIdentifiers.notifications],
    queryFn: () => new Notifications(OpenUpHttpClient).getNotifications(),
    select: (notifications) =>
      notifications.filter(
        (n) => !excludedNotificationKeys.includes(n.key ?? ""),
      ),
    staleTime: hours(1),
  });
};

export const useReadNotificationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: number) =>
      new Notifications(OpenUpHttpClient).readNotification(notificationId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryIdentifiers.notifications],
      });
    },
  });
};
